import React, {useEffect, useState} from 'react'
import {Wrapper} from "./credical.style"
import credicalLogo from "@core/ui/static/images/credical.png";

const tgc = 22
const tgcRate = (1 + tgc / 100)

const Credical = ({origPrice = 0}) => {

  const [price, setPrice] = useState(0)
  const [income, setIncome] = useState('0')
  const [buyOpt, setBuyOpt] = useState(0)
  const [duration, setDuration] = useState('3')
  const [leasing, setLeasing] = useState(0)
  const [rate, setRate] = useState(13.5)
  const [incomeWarning, setIncomeWarning] = useState(null)
  const hasIncome = () => {
    return income > 0
  }

  const simulate = () => {
    const priceExcTax = Math.round(price / tgcRate)
    const optionAchat = Math.round(price * 0.05)
    const optionAchatHt = Math.round(optionAchat / tgcRate)
    setBuyOpt(optionAchat)
    const durationTotal = hasIncome() ? duration * 12 - 1 : duration * 12
    const rateAnnual = rate / 12 / 100
    const pv = hasIncome() ? priceExcTax - (Math.round(income / tgcRate)) : priceExcTax
    const fv = -optionAchatHt
    const leasingExcTax = calculate(rateAnnual, durationTotal, pv, fv, hasIncome())
    const leasingTaxAmount = Math.floor(leasingExcTax * tgc / 100)
    setLeasing(leasingExcTax + leasingTaxAmount)
  }

  const calculate = (rateAnnual, duration, pv, fv, type) => {
    const total = -rateAnnual * (pv * Math.pow(1 + rateAnnual, duration) + fv) / ((1 + rateAnnual * (type ? 0 : 1)) * (Math.pow(1 + rateAnnual, duration) - 1))
    return Math.ceil(total * -1)
  }

  const formatNumber = (number) => {
    return parseInt(number).toLocaleString('fr-FR')
  }

  const checkIncome = (value) => {
    if (isNaN(value) || !value) {
      setIncomeWarning(null)
      return setIncome(0)
    }
    if (parseInt(value) > parseInt(price) / 1.2) {
      setIncome(price / 1.2)
      setIncomeWarning('Veuillez vérifier votre apport')
    } else {
      setIncome(value)
      setIncomeWarning(null)
    }
  }

  const checkPrice = (value) => {
    if (value) {
      setPrice(value)
    } else {
      setPrice(0)
      setLeasing(0)
    }
  }

  useEffect(() => {
    setPrice(origPrice)
  }, [])

  useEffect(() => {
    simulate()
  }, [rate])

  useEffect(() => {
    if (price) {
      if (price >= 2000000 && price < 4000000) {
        setRate(12.5)
      } else if (price >= 4000000 && price < 6000000) {
        setRate(11.5)
      } else if (price >= 6000000) {
        setRate(9.5)
      }
      simulate()
    }
  }, [duration, income, price])

  return (
    <Wrapper>
      <h3 className="center">Simulateur de leasing</h3>
      <p className="center">
        <img src={credicalLogo} alt="Simulateur de leasing Crédical" className="logo"/>
      </p>
      <div className="simulator">
        <p className="price">
          <label htmlFor="price">Prix</label>
          <input id="price" placeholder="Prix" onChange={(e) => checkPrice(e.target.value.replace(/\s/g, ''))}
                 value={formatNumber(price)}/>
        </p>
        <p className={`price ${incomeWarning ? 'error' : ''}`}>
          <label htmlFor="income">Apport</label>
          <input id="income" placeholder="Apport" onChange={(e) => checkIncome(e.target.value.replace(/\s/g, ''))} value={formatNumber(income)}/>
          <span className="error">
            {incomeWarning}
          </span>
        </p>
        <p>
          <label>Durée</label>
          <select onChange={(e) => setDuration(e.target.value)}>
            <option selected={duration === '3'} value={3}>3</option>
            <option selected={duration === '4'} value={4}>4</option>
            <option selected={duration === '5'} value={5}>5</option>
          </select>
        </p>
        <p className="price">
          <label htmlFor="leasing">Option d’achat</label>
          <input id="leasing" value={formatNumber(buyOpt)} disabled/>
        </p>
        <p className="price">
          <label htmlFor="leasing">Loyer</label>
          <input id="leasing" value={formatNumber(leasing)} disabled/>
        </p>
      </div>
      <div className="center legals">
        <p>
            Ou contactez-nous directement par téléphone au <strong style={{color: 'rgb(237,125,49)'}}>25 79 79</strong><br/>
            Ou par email à <strong>credical@credical.nc</strong>
        </p>
        <p>
          Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.
        </p>
        <p>
          Ces documents n'ont pas valeur de contrat et ne sauraient engager la responsabilité de Credical.
        </p>
        <p>
          Toutes les données fournies à partir de ces applications sont indicatives. Pour toute étude de crédit, il
          conviendra de vous rapprocher de l’équipe commerciale Credical.
        </p>
      </div>
    </Wrapper>
  )
}

export default Credical;
